import React from 'react';
import { Link } from 'react-scroll';
import { FaFacebookF, FaSnapchatGhost, FaTiktok, FaInstagram, FaPaperPlane } from 'react-icons/fa';
import logo from '../assets/images/logo-transparent-blanc.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <img src={logo} alt="Drive Inter" className="footer-logo" />
            <p>Votre partenaire de confiance pour toutes vos solutions professionnelles.</p>
            <div className="social-links">
              <a href="#" aria-label="Facebook"><FaFacebookF /></a>
              <a href="#" aria-label="Instagram"><FaInstagram /></a>
              <a href="#" aria-label="Snapchat"><FaSnapchatGhost /></a>
              <a href="#" aria-label="TikTok"><FaTiktok /></a>
            </div>
          </div>
          <div className="footer-section">
            <h4>Liens Rapides</h4>
            <ul>
              <li><Link to="hero" smooth={true} duration={500}>Accueil</Link></li>
              <li><Link to="services" smooth={true} duration={500}>Services</Link></li>
              <li><Link to="about" smooth={true} duration={500}>À Propos</Link></li>
              <li><Link to="contact" smooth={true} duration={500}>Contact</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><a href="#">Transport & Logistique</a></li>
              <li><a href="#">Gestion Administrative</a></li>
              <li><a href="#">Conseil Stratégique</a></li>
              <li><a href="#">Support Client</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Newsletter</h4>
            <p>Inscrivez-vous pour recevoir nos actualités</p>
            <form className="newsletter-form" onSubmit={(e) => e.preventDefault()}>
              <input type="email" placeholder="Votre email" />
              <button type="submit"><FaPaperPlane /></button>
            </form>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 Drive Inter. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
